module.exports = __webpack_public_path__ + "static/media/img010.9ff43fb7.jpg";